import React from 'react';

import { HostModuleProvider } from 'scbk-services';

import { CoreModuleRoutes } from '@/routes';

import 'scbk-ui-web/dist/global.css';

const HostModule: React.FC = () => {
    return (
        <HostModuleProvider>
            <CoreModuleRoutes />
        </HostModuleProvider>
    );
};

const App: React.FC = () => {
    return <HostModule />;
};

export default App;
